import { css } from '@emotion/react';

import { theme } from 'src/styles/theme';

export const styles = {
    loginDialogDrawer: css({
        [theme.breakpoints.up('lg')]: {
            display: 'none',
        },
        '.MuiDrawer-paper': {
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            alignItems: 'flex-start',
            padding: '70px 20px 30px 20px',
            borderRadius: '15px 15px 0px 0px',
            backgroundColor: 'white',
        },
    }),

    loginDialogModal: css({
        [theme.breakpoints.down('lg')]: {
            display: 'none',
        },
    }),
    loginDialogPaper: css({
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%) translateX(-50%)',
        left: '50%',
        borderRadius: '23px',
        backgroundColor: theme.palette.background.default,
    }),
    loginDialogCloseButton: css({
        position: 'absolute',
        top: '20px',
        right: '20px',
        [theme.breakpoints.up('lg')]: {
            top: '25px',
            right: '25px',
        },
    }),
};
